import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { ShieldCheck, ShieldAlert } from "lucide-react";

export default function VerifiedBadge({ verified, name, verifiedAt, size = "default" }) {
  const Icon = verified ? ShieldCheck : ShieldAlert;
  const color = verified ? "text-green-400 border-green-400/40 bg-green-400/10" : "text-amber-400 border-amber-400/40 bg-amber-400/10";
  const cls = size === "sm" ? "h-6 px-2 text-[10px]" : "h-7 px-2.5 text-xs";
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid="verified-badge" className={`inline-flex items-center gap-1 rounded-full border ${color} ${cls} font-bold uppercase tracking-wider hover:brightness-125 transition`}>
          <Icon className={size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"}/>
          {verified ? "Verified" : "Pending"}
        </button>
      </PopoverTrigger>
      <PopoverContent className="bg-zinc-900 border-zinc-700 text-zinc-100 max-w-xs">
        {verified ? (
          <>
            <div className="font-bold text-green-400 flex items-center gap-2 text-sm"><ShieldCheck className="h-4 w-4"/>Driver Verified with Background Check</div>
            <p className="text-xs text-zinc-400 mt-1.5">{name || "This driver"} has completed identity verification, license check, and a background screening administered by Buller Taxi Services, LLC.</p>
            {verifiedAt && <div className="text-[10px] text-zinc-500 mt-2">Verified on {new Date(verifiedAt).toLocaleDateString()}</div>}
          </>
        ) : (
          <>
            <div className="font-bold text-amber-400 flex items-center gap-2 text-sm"><ShieldAlert className="h-4 w-4"/>Pending Verification</div>
            <p className="text-xs text-zinc-400 mt-1.5">This driver's account is awaiting administrative review and a background check before activation.</p>
          </>
        )}
      </PopoverContent>
    </Popover>
  );
}
